import { Pipe, PipeTransform } from '@angular/core';

/**
 * Generated class for the OrderbyPipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
  name: 'orderby',
})
export class OrderbyPipe implements PipeTransform {

  transform(items: any[], filter: string): any {
    if (!items || !filter) {
        return items;
    } else {
      if(filter == 'asc'){
        //return items.sort((a, b) => (a.AssetName > b.AssetName) ? 1 : ((b.AssetName > a.AssetName) ? -1 : 0));
        return items.sort((a, b) => (a.AssetName).localeCompare(b.AssetName))
      }
      if(filter == 'date'){
        return items.sort((a, b) => {
            return +new Date(b.AssetDate) - +new Date(a.AssetDate)
          });
      }
    }

  }
}



// WEBPACK FOOTER //
// ./src/pipes/orderby/orderby.ts